import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email", "form", "success", "error", "flash"]

  async requestMagicLink(event) {
    event.preventDefault()

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch(this.formTarget.action, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          email: this.emailTarget.value
        })
      })

      const data = await response.json()

      if (response.ok) {
        this.formTarget.classList.add("hidden")
        this.successTarget.classList.remove("hidden")
        this.errorTarget.classList.add("hidden")
        // Hide flash message if it exists
        if (this.hasFlashTarget) {
          this.flashTarget.classList.add("hidden")
        }
      } else {
        this.errorTarget.textContent = data.error
        this.errorTarget.classList.remove("hidden")
        this.successTarget.classList.add("hidden")
        // Hide flash message if it exists
        if (this.hasFlashTarget) {
          this.flashTarget.classList.add("hidden")
        }
      }
    } catch (error) {
      this.errorTarget.textContent = "An error occurred. Please try again."
      this.errorTarget.classList.remove("hidden")
      this.successTarget.classList.add("hidden")
      // Hide flash message if it exists
      if (this.hasFlashTarget) {
        this.flashTarget.classList.add("hidden")
      }
    }
  }
}
